module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_6005.d1b4128e.png";